import { Menu, useGetList } from 'react-admin';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import { useTheme } from '@mui/material/styles';

interface MenuItemWithNumberOfNewItemsProps {
    to: string;
    primaryText: string;
    leftIcon: any;
    sx: any;
}

const MenuItemWithNumberOfNewItems = (
    props: MenuItemWithNumberOfNewItemsProps
) => {
    const { data } = useGetList(props.to, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'CreatedAt', order: 'DESC' },
        filter: {
            status: 'Free',
        },
    });
    return (
        <Menu.Item
            to={props.to}
            primaryText={`${props.primaryText} (${data?.length})`}
            leftIcon={props.leftIcon}
            sx={props.sx}
        />
    );
};

export const CustomMenu = () => {
    const theme = useTheme();
    // @ts-ignore
    const mainColor = theme.palette?.primary?.main ?? '#42C9AD';

    const activeStyle = {
        '&.RaMenuItemLink-active': {
            border: `2px solid ${mainColor}`,
            color: mainColor,
        },
    };

    return (
        <Menu>
            <Menu.Item
                to="document-group"
                primaryText="Ügylettípusok"
                leftIcon={<ListAltOutlinedIcon />}
                sx={activeStyle}
            />
            <Menu.Item
                to="document"
                primaryText="Nyomtatványok"
                leftIcon={<ArticleOutlinedIcon />}
                sx={activeStyle}
            />
            <MenuItemWithNumberOfNewItems
                to="unique-request"
                primaryText="Bejelentések"
                leftIcon={<PendingActionsIcon />}
                sx={activeStyle}
            />
            <Menu.Item
                to="request/_EInvoice"
                primaryText="Elektronikus számla igénylések"
                leftIcon={<AlternateEmailOutlinedIcon />}
                sx={activeStyle}
            />
            <Menu.Item
                to="static-content"
                primaryText="Rendszer paraméterek"
                leftIcon={<DesignServicesOutlinedIcon />}
                sx={activeStyle}
            />
            <Menu.Item
                to="web-user"
                primaryText="Felhasználók"
                leftIcon={<PersonOutlineOutlinedIcon />}
                sx={activeStyle}
            />
            <Menu.Item
                to="admin-user"
                primaryText="Admin felhasználók"
                leftIcon={<SupervisorAccountOutlinedIcon />}
                sx={activeStyle}
            />
        </Menu>
    );
};
